import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
  faExclamationTriangle,
  faInfoCircle,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

const TOAST_CONFIG = {
  success: {
    icon: faCheckCircle,
    title: "Success",
    iconBg: "bg-green-100",
    iconColor: "text-green-600",
    titleColor: "text-green-700",
  },
  error: {
    icon: faTimesCircle,
    title: "Error",
    iconBg: "bg-red-100",
    iconColor: "text-red-600",
    titleColor: "text-red-700",
  },
  warning: {
    icon: faExclamationTriangle,
    title: "Warning",
    iconBg: "bg-amber-100",
    iconColor: "text-amber-600",
    titleColor: "text-amber-700",
  },
  info: {
    icon: faInfoCircle,
    title: "Information",
    iconBg: "bg-blue-100",
    iconColor: "text-blue-600",
    titleColor: "text-blue-700",
  },
};

export const showToast = (type = "info", message = "", options = {}) => {
  const cfg = TOAST_CONFIG[type] || TOAST_CONFIG.info;

  const defaultOptions = {
    position: "bottom-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    closeButton: false,
    theme: "light",
    ...options,
  };


  const Content = ({ closeToast }) => (
    <div className="flex items-start gap-3 relative w-full">
      <div className="flex-shrink-0 mt-0.5">
        <div
          className={`w-9 h-9 rounded-full flex items-center justify-center ${cfg.iconBg} shadow-sm`}
        >
          <FontAwesomeIcon icon={cfg.icon} className={`h-4 w-4 ${cfg.iconColor}`} />
        </div>
      </div>

      <div className="flex-1 min-w-0 pr-5">
        <p className={`text-[11px] font-semibold uppercase tracking-wider mb-0.5 ${cfg.titleColor}`}>
          {cfg.title}
        </p>
        <p className="text-sm text-gray-700 leading-relaxed font-medium break-words">
          {message}
        </p>
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation();
          closeToast();
        }}
        className="group absolute -top-1 -right-1 flex items-center justify-center w-6 h-6 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 hover:text-gray-700 transition-all duration-200 hover:scale-110"
        aria-label="Close toast"
      >
        <FontAwesomeIcon icon={faXmark} className="h-3 w-3" />
      </button>
    </div>
  );

  toast(Content, {
    ...defaultOptions,
    className: `custom-toast custom-toast--${type}`,
  });
};

export const toastSuccess = (message, options = {}) => showToast("success", message, options);
export const toastError = (message, options = {}) => showToast("error", message, options);
export const toastWarning = (message, options = {}) => showToast("warning", message, options);
export const toastInfo = (message, options = {}) => showToast("info", message, options);